import { LOGO_URL } from "@/lib/pfc";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative bg-ink-800 border-b border-white/5 py-24 overflow-hidden splatter-blue grain">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10 relative">
          <img src={LOGO_URL} alt="PFC" className="h-24 w-24 mb-8 object-contain" />
          <div className="label text-pfc-gold mb-3">About Us</div>
          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white uppercase leading-[0.85]">
            We <span className="gold-text">Spotlight</span> the<br /> Ones the World <span className="silver-text">Should</span> Know.
          </h1>
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-5 lg:px-10 py-20 text-white/85 font-body text-lg leading-relaxed space-y-8">
        <p>
          <strong className="text-pfc-gold">Public Figures Campaign</strong> is a digital media and promotional platform dedicated to spotlighting talented individuals, entrepreneurs, and creative projects from around the world. We’re a magazine, a press network, and a promotional hub — built for the rising and the relentless.
        </p>
        <p>
          We give talented people a place to tell their stories, build their brands, and connect with new audiences while showcasing their achievements to the world. From bedroom artists to runway models, streetball legends to underground filmmakers, founders to disruptors — PFC is the campaign behind their come-up.
        </p>

        <div className="grid sm:grid-cols-3 gap-6 my-12">
          {[
            { num: "100+", label: "Featured Talent" },
            { num: "5", label: "Cultural Categories" },
            { num: "2026", label: "Annual Print Edition" },
          ].map((s) => (
            <div key={s.label} className="pfc-card p-8 text-center">
              <div className="font-display text-5xl gold-text">{s.num}</div>
              <div className="label text-white/60 mt-3">{s.label}</div>
            </div>
          ))}
        </div>

        <h2 className="font-display text-4xl text-white uppercase mt-12">Our <span className="gold-text">Mission</span></h2>
        <p>
          Promoting talent. Elevating brands. Inspiring the world. Three sentences — one campaign. We believe the next icons are already here; they just need a stage. PFC is that stage: editorial-grade storytelling, professional exposure, and a network built on relationships, not algorithms.
        </p>
      </section>
    </div>
  );
}
